import type { IFlowClarificationAnswers, INicheAnalysisResponse, INicheClarificationQuestion } from 'src/services/NicheAnalysisService';

// This marker tracks the input of a completed analysis, not a readiness questionnaire.
export const FLOW_ANALYSIS_CONTRACT_VERSION = 'flow_analysis_v2';

export const normalizeFlowAnswers = (_answers: IFlowClarificationAnswers | null | undefined): Required<IFlowClarificationAnswers> => ({ offering: '', wanted_requests: '' });

export const flowInputIdentity = (serviceDescription: string, _answers: IFlowClarificationAnswers) => JSON.stringify({ serviceDescription });

export const isCurrentFlowAnalysis = (
    analysis: INicheAnalysisResponse | null | undefined,
    serviceDescription: string,
    _answers: IFlowClarificationAnswers
) => analysis?.status === 'ready' &&
    analysis.contract_version === FLOW_ANALYSIS_CONTRACT_VERSION &&
    analysis.analysis_input?.service_description === serviceDescription;

export const buildResolvedFlowDescription = (businessDescription: string, _answers: IFlowClarificationAnswers) => businessDescription.trim();

export const acceptFlowAnalysis = (result: INicheAnalysisResponse, serviceDescription: string): INicheAnalysisResponse => {
    if (!Array.isArray(result.keywords) || !Array.isArray(result.lead_examples)) {
        throw new Error('Не удалось получить результат анализа. Повторите попытку.');
    }
    return {
        ...result,
        status: 'ready',
        contract_version: FLOW_ANALYSIS_CONTRACT_VERSION,
        analysis_input: { service_description: serviceDescription, clarification_answers: {} },
    };
};

// Old persisted drafts may contain questionnaire data. It must never render another field.
export const FlowClarificationFields = (_props: {
    questions: INicheClarificationQuestion[];
    answers: IFlowClarificationAnswers;
    retryRequired: boolean;
    onChange: (id: INicheClarificationQuestion['id'], value: string) => void;
}) => null;
